<section class="auction-inventory mt-4">
  <div class="container-fluid">
    <div class="auction-inventory__tools d-block mb-3">
      <div class="auction-inventory__search mr-3">
        <!-- start -->
        <div class="row mx-2 my-3" *ngIf="activeTab === 'vehicle'">
          <!-- Make -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="make">Make</label>
            <select
              id="make"
              class="form-control"
              name="Make"
              (change)="searchProductsFromList($event)"
            >
              <option value="" disabled selected>Please select make</option>
              <ng-container *ngFor="let item of makes | keyvalue; index as i">
                <option value="{{ item.key }}">
                  {{ item.key }} ({{ item.value }})
                </option>
              </ng-container>
            </select>
          </div>

          <!-- Model -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="model">Model</label>
            <select
              id="model"
              class="form-control"
              name="Model"
              (change)="searchProductsFromList($event)"
            >
              <option value="" disabled selected>Please select model</option>
              <ng-container *ngFor="let item of models | keyvalue; index as i">
                <option value="{{ item.key }}">
                  {{ item.key }} ({{ item.value }})
                </option>
              </ng-container>
            </select>
          </div>

          <!-- Trim/Type -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="trim-type">Trim/Type</label>
            <select
              id="trim-type"
              class="form-control"
              name="Trim/Type"
              (change)="searchProductsFromList($event)"
            >
              <option value="" disabled selected>
                Please select trim/type
              </option>
              <ng-container
                *ngFor="let item of trimType | keyvalue; index as i"
              >
                <option value="{{ item.key }}">
                  {{ item.key }} ({{ item.value }})
                </option>
              </ng-container>
            </select>
          </div>

          <!-- Model Year -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="model-year">Model Year</label>
            <select
              id="model-year"
              class="form-control"
              name="Model Year"
              (change)="searchProductsFromList($event)"
            >
              <option value="" disabled selected>
                Please select model year
              </option>
              <ng-container
                *ngFor="let item of modelYears | keyvalue; index as i"
              >
                <option value="{{ item.key }}">
                  {{ item.key }} ({{ item.value }})
                </option>
              </ng-container>
            </select>
          </div>

          <!-- Exterior Color -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="exterior-color">Exterior Color</label>
            <select
              id="exterior-color"
              class="form-control"
              name="Exterior Colour"
              (change)="searchProductsFromList($event)"
            >
              <option value="" disabled selected>
                Please select exterior color
              </option>
              <ng-container
                *ngFor="let item of exteriorColor | keyvalue; index as i"
              >
                <option value="{{ item.key }}">
                  {{ item.key }} ({{ item.value }})
                </option>
              </ng-container>
            </select>
          </div>

          <!-- VIN -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="vin-number">VIN</label>
            <input
              type="text"
              placeholder="Please type a VIN"
              name="VIN Number"
              class="form-control mb-2"
              id="vin-number"
              (input)="searchProductsFromList($event)"
            />
          </div>

          <!-- Registration Number -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label for="registration-number">Registration Number</label>
            <input
              type="text"
              placeholder="Please type a Registration number"
              name="Plate Number"
              class="form-control mb-2"
              id="registration-number"
              (input)="searchProductsFromList($event)"
            />
          </div>

          <!-- Reset Button -->
          <div class="col-12">
            <button
              *ngIf="isFilterMode"
              (click)="resetFilter()"
              class="btn btn__main2 curved fw-500"
              style="
                float: right;
                color: #212529 !important;
                background-color: #ffc107;
                border-color: #ffc107;
              "
            >
              Reset
            </button>
          </div>
        </div>
        <!-- end -->

        <div
          class="credential3__input-group auction-inventory__searchfield"
          *ngIf="activeTab === 'batch'"
        >
          <span class="credential3__icon">
            <ion-icon name="search-outline" class="ion-lg"></ion-icon>
          </span>
          <input
            type="text"
            placeholder="Type a batch name"
            class="form-control credential3__icon-input"
            id="dt-inventory-search"
            (input)="searchBatch($event)"
          />
        </div>
      </div>

      <div class="auction-inventory__toolBtnGrp">
        <!-- <ng-container *ngIf="activeTab === 'vehicle'">
          <div class="mx-4 d-flex align-items-center justify-content-between">
            <div *ngIf="selectedRows.length" class="d-flex align-items-end">

                <label for="row-action"
                  >Row actions ({{ selectedRows.length }} {{ selectedRows.length > 1 ? 'rows' : 'row' }} will effected)</label
                >
                <select id="row-action" class="form-control">
                  <option value="" disabled selected>Please select an action</option>
                  <option value="1">Reserve</option>
                  <option value="1">Unreserve</option>
                  <option value="1">Sold</option>
                  <option value="1">Unsold</option>
                </select>


              <button type="button" class="btn btn-outline-dark ml-1" style="border-radius: 0.25rem">Update</button>
            </div>

            <button class="btn btn__main2 ml-auto" routerLink="add-new-vehicle" *ngIf="activeTab === 'vehicle'">
              <ion-icon name="add-circle" class="ion-lg mr-sm-2"></ion-icon>
              <span class="">Add new vehicle</span>
            </button>
          </div>
        </ng-container> -->

        <button
          class="btn btn__main2 ml-auto"
          routerLink="add-new-batch"
          *ngIf="activeTab === 'batch'"
        >
          <ion-icon name="add-circle" class="ion-lg mr-sm-2"></ion-icon>
          <!-- d-none d-sm-block -->
          <span class="d-none d-sm-block">Create Batch</span>
        </button>
      </div>
    </div>

    <div class="card auction-content-main m-0">
      <div class="auction-content-body position-relative py-4">
        <tabset>
          <tab
            heading="Vehicles"
            (selectTab)="tabSwitch('vehicle')"
            [active]="activeTab === 'vehicle'"
          >
            <!-- Vehicles table with no-filter -->
            <div *ngIf="activeTab === 'vehicle' && noFilterMode">
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table
                datatable
                [dtOptions]="auctionVehicleTableDtOptions"
                id="auction-vehicles"
                class="row-border hover"
              >
                <thead>
                  <tr>
                    <th *ngFor="let thead of auctionTableTheads">
                      {{ thead }}
                    </th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

            <!-- Vehicles table with filter -->
            <div *ngIf="activeTab === 'vehicle' && isFilterMode">
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table
                datatable
                [dtOptions]="auctionVehicleTableDtOptions2"
                id="auction-vehicles"
                class="row-border hover"
              >
                <thead>
                  <tr>
                    <th *ngFor="let thead of auctionTableTheads">
                      {{ thead }}
                    </th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </tab>

          <tab
            heading="Batches"
            (selectTab)="tabSwitch('batch')"
            [active]="activeTab === 'batch'"
          >
            <!-- Batch table with no-filter -->
            <div *ngIf="activeTab === 'batch' && noFilterMode">
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table
                datatable
                [dtOptions]="batchTableDtOptions"
                id="batch-vehicles"
                class="row-border hover"
              >
                <thead>
                  <tr>
                    <th *ngFor="let thead of batchTableTheads">
                      {{ thead }}
                    </th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

            <!-- Batch table with filter -->
            <div *ngIf="activeTab === 'batch' && isFilterMode">
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table
                datatable
                [dtOptions]="batchTableDtOptions2"
                id="batch-vehicles"
                class="row-border hover"
              >
                <thead>
                  <tr>
                    <th *ngFor="let thead of batchTableTheads">
                      {{ thead }}
                    </th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </tab>

          <tab
            heading="Sold"
            (selectTab)="tabSwitch('sold')"
            [active]="activeTab === 'sold'"
          >
            <tabset>
              <tab
                heading="Individual"
                (selectTab)="nestedTabSwitch('individual')"
                [active]="nestedActiveTab === 'individual'"
              >
                <div *ngIf="nestedActiveTab === 'individual' && noFilterMode">
                  <p *ngIf="!tableData.length" class="m-0">No data found</p>
                  <table
                    datatable
                    [dtOptions]="soldIndividualTableDtOptions"
                    id="sold-vehicles"
                    class="row-border hover"
                  >
                    <thead>
                      <tr>
                        <th *ngFor="let thead of soldIndividualTableTheads">
                          {{ thead }}
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </tab>

              <tab
                heading="Bulk"
                (selectTab)="nestedTabSwitch('bulk')"
                [active]="nestedActiveTab === 'bulk'"
              >
                <div *ngIf="nestedActiveTab === 'bulk' && noFilterMode">
                  <p *ngIf="!tableData.length" class="m-0">No data found</p>
                  <table
                    datatable
                    [dtOptions]="soldBulkTableDtOptions"
                    id="sold-vehicles"
                    class="row-border hover"
                  >
                    <thead>
                      <tr>
                        <th *ngFor="let thead of soldBulkTableTheads">
                          {{ thead }}
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </tab>

              <tab
                heading="Auction"
                (selectTab)="nestedTabSwitch('auction')"
                [active]="nestedActiveTab === 'auction'"
              >
                <div *ngIf="nestedActiveTab === 'auction'">
                  <p *ngIf="!tableData.length" class="m-0">No data found</p>
                  <table
                    datatable
                    [dtOptions]="soldCarListTableDtOptions"
                    id="sold-vehicles"
                    class="row-border hover"
                  >
                    <thead>
                      <tr>
                        <th *ngFor="let thead of soldCarListTableTheads">
                          {{ thead }}
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </tab>
            </tabset>
          </tab>
        </tabset>
      </div>
    </div>
  </div>
</section>

<ng-template #template>
  <div class="modal-body text-center">
    <p>Do you want to confirm?</p>
    <button
      type="button"
      class="btn btn-default"
      (click)="confirmDelete()"
      [ladda]="laddaLoading"
    >
      Yes
    </button>
    <button type="button" class="btn btn-primary" (click)="modalRef?.hide()">
      No
    </button>
  </div>
</ng-template>

<ng-template #confirmModal>
  <div class="modal-body text-center">
    <p>Are you sure?</p>
    <p>{{ actionMessage }}</p>
    <button
      type="button"
      class="btn btn-secondary mr-1"
      style="border-radius: 4px"
      (click)="confirmAction()"
      [ladda]="actionInProgress"
    >
      Yes
    </button>
    <button
      type="button"
      class="btn btn-danger"
      style="border-radius: 4px"
      (click)="cancleAction()"
    >
      No
    </button>
  </div>
</ng-template>
